import { render, staticRenderFns } from "./PesquisaAvancada.vue?vue&type=template&id=753f8b0d&lang=pug"
import script from "./PesquisaAvancada.vue?vue&type=script&lang=js"
export * from "./PesquisaAvancada.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAvancada.vue?vue&type=style&index=0&id=753f8b0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports